import Image from 'app/Components/Shared/Image/image';
import React from "react";
import { Container, Row } from "reactstrap";
import BtnSubmit from "../../Shared/Buttons/BtnSubmit";
import BtnWhite from "../../Shared/Buttons/BtnWhite";
import EpiContext from "@episerver/spa-core/Spa";
import { gtag4 } from "../../../utilities/analytics/tracking";
import Config from "../../../Config";

const ImeiChangeSuccsess = (props) => {
  let title;
  if (props.isAdd) {
    title = "להוספת";
  }
  if (props.isRemove) {
    title = "להסרת";
  }

  return (
    <Container className="imei-change-success" fluid>
      <div className="client-information-change-hetPay-text">
        <Row className="justify-content-center">
          <Image src={require("./success.svg")} />{" "}
        </Row>
        <Row className="justify-content-center">
          <span className="title-att">בקשתך {title} IMEI הושלמה בהצלחה!</span>
        </Row>
        <Row className="justify-content-center ">
          {props.isAdd && (
            <>
              <span className="popup-title">
                מספר הIMEI החדש יתעדכן ברגעים הקרובים
              </span>
              <span className="popup-title">
                {" "}
                להוספת שירות אמש"ת יש לפנות לאחראי/ת השירות{" "}
              </span>
            </>
          )}
          {props.isRemove && (
            <span className="popup-title">
              מספר הIMEI הישן ימחק ברגעים הקרובים
            </span>
          )}
        </Row>
      </div>

      <Row className="justify-content-center mt-2">
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            props.onClick();
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

export default ImeiChangeSuccsess;
